"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlugPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
let SlugPipe = class SlugPipe {
    transform(value) {
        let slugged = (value.toLowerCase()).replace(/\W+/g, "-");
        return slugged;
    }
};
exports.SlugPipe = SlugPipe;
exports.SlugPipe = SlugPipe = __decorate([
    (0, core_1.Pipe)({ name: 'slug' })
], SlugPipe);
//# sourceMappingURL=slug.pipe.js.map